import { useEffect, useState } from "react";
import useHashConnect from "./useHashConnect";

export default function useAPY() {
  const [apy, setAPY] = useState<number>(100);
  const [apr, setAPR] = useState<number>(100);
  const { firestoreData, tvl } = useHashConnect();

  useEffect(() => {
    if (tvl > 0 && firestoreData) {
      const apr =
        firestoreData?.prStakingAPR +
        (firestoreData?.emissionRate * 365 * 100) / tvl;
      setAPR(apr);
    }
  }, [tvl, firestoreData]);

  useEffect(() => {
    if (tvl > 0) {
      const apy = ((1 + apr / (100 * 365)) ** 365 - 1) * 100;
      setAPY(apy);
    }
  }, [apr]);

  return { apy, apr };
}
